<!-- eslint-disable vue/no-mutating-props -->
 
<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-unused-vars -->
<template>
    <component :class="[$style['mds-card'], $style['cf-card-cardWrap-basic'], backgroundstyle()]" :is="componentType"
        :href="href">
        <div v-if="label" :class="$style['mds-card__label']">
            <div :class="$style['mds-card__label-title']">{{ label }}</div>
        </div>

        <div :class="[$style['mds-card-image'], $style['cf-card-image-basic']]">
            <div :class="[$style['cf-card-profileWraper']]">
                <mds-profile-image :src="imagepath" :height="imageheight" :width="imagewidth"
                    alt="Author Photo"></mds-profile-image>
            </div>
            <div :class="$style['mds-card-caption']">
                <div>
                    <div :class="$style['mds-card__title']">
                        <slot>{{ title }}</slot>
                    </div>
                    <div v-if="caption" :class="[$style['mds-card__caption']]" v-html="caption"></div>
                </div>

                <div :class="$style['cf-floatingBtns']" v-if="showbutton">
                    <div>
                        <mds-button variation="secondary" type="button" @click="clicked1()">{{
                            firstButtonText
                        }}</mds-button>
                    </div>

                    <div :class="$style['mds-button-card']">
                        <mds-button variation="secondary" type="button" @click="clicked2()">{{
                            secondButtonText
                        }}</mds-button>
                    </div>
                </div>
            </div>
        </div>
    </component>
</template>

<script>
import MdsProfileImage from '@mds/profile-image';
import MdsCard from '@mds/card';
import { MdsButton, MdsButtonContainer } from '@mds/button';
import MdsIcon from '@mds/icon';



export default {
    name: 'AdlCard',
    components: {
        MdsCard, MdsButton, MdsProfileImage, MdsButtonContainer, MdsIcon

    },
    props: {
        disabled: { type: Boolean, default: true },
        firstButtonText: { type: String },
        secondButtonText: { type: String },
        imagepath: { type: String },
        showbutton: { type: Boolean, default: false },
        caption: {
            type: String,
            docs: {
                validation: '—',
                description: 'Sets the card caption.',
                support: ['v-html'],
            },
        },

        href: {
            type: String,
            docs: {
                validation: '—',
                description: 'When provided, makes the entire card a link and sets the `href` path.',
            },
        },
        label: {
            type: String,
            docs: {
                validation: '—',
                description: 'Sets the card label.',
            },
        },
        metadata: {
            type: String,
            docs: {
                validation: '—',
                description: 'Sets the card metadata.',
                support: ['v-html'],
            },
        },
        size: {
            type: String,
            default: 'medium',
            validator(value) {
                return ['small', 'medium', 'large'].indexOf(value) !== -1;
            },
            docs: {
                validation: 'One of: `small`, `medium`, `large`.',
                description: 'Sets the size of the card.',
            },
        },
        title: {
            type: String,
            required: true,
            docs: {
                validation: '**Required**',
                description: 'Sets the card title.',
            },
        },
        imageheight: {
            type: String
        },
        imagewidth: {
            type: String
        }

    },
    computed: {

        componentType() {
            return this.isRoutable ? this.linkTag : this.href ? 'a' : 'div';
        },
        sizeClass() {
            return this.$style[`mds-card--${this.size}`];
        },

        classObject() {
            const obj = {};
            obj[this.$style['mds-card--full-bleed']] = this.fullBleed;
            obj[this.$style['mds-card--full-bleed-top-label-overlap']] =
                this.supplementalContentFirst && this.fullBleed;

            return obj;
        }


    },
    methods: {
        backgroundstyle() {
            const obj = {};
            obj[this.$style['mds-disabled-card']] = this.disabled;
            return obj;
        },
        clicked1() {
            this.$emit('clicked1');
        },
        clicked2() {
            this.$emit('clicked2');
        },
    },

    data() {
        return {

        };
    },
    watch: {
        firstOptionLabel(val) {
            this.firstlabel = val;
        },
        secondOptionLabel(val) {
            this.secondlabel = val;

        }
    }
};

</script>
<style scoped lang="scss" module>
@import './card.scss';

.cf-card-cardWrap-engagement {
    padding: $mds-space-2-x $mds-space-2-x !important;
    width: 100%;
}

.cf-card-cardWrap-basic {
    padding: $mds-space-3-x $mds-space-2-x !important;
}

.mds-disabled-card {
    background-color: #e5e5e5;
}

.mds-card {
    .cf-card-image-engagement {
        position: relative;
        padding-left: 56px;

        .mds-card-caption {
            min-width: 100% !important;
            margin-left: 0px !important;
        }
    }

    .cf-card-image-basic {
        position: relative;
        padding-left: 56px;

        .mds-card-caption {
            min-width: 270px !important;
            margin-left: 0px !important;
            min-height: 74px;
        }
    }

    .cf-card-title-engagement {
        @include mds-level-6-heading($bold: true);
        margin-bottom: 0;
        margin-top: 0px;
        font-size: 14px !important;
    }

    .cf-card-profileWraper {
        position: absolute;
        left: 0;
    }

    .cf-card-ButonsWrap>.cf-card-ButonsSingle {
        width: 50%;
        text-align: left;
        cursor: pointer;
        display: inline-flex;
        font-size: 14px;
    }

    .cf-card-ButonsWrap>.cf-card-ButonsSingle+.cf-card-ButonsSingle {
        padding-left: 8px
    }

    .cf-card-ButonsWrap>.cf-card-ButonsSingle>span {
        text-overflow: ellipsis;
        white-space: nowrap !important;
        overflow: hidden;

    }

    .cf-card-ButonsWrap>.cf-card-ButonsSingle .caretICon {
        position: relative;
        top: 5px
    }
}
</style>